import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SocialPolaroid {
  id: string;
  image_url: string;
  caption: string;
  alt_text: string;
  position: number;
  is_active: boolean;
}

export const useSocialPolaroids = () => {
  const [data, setData] = useState<SocialPolaroid[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data: rows, error } = await supabase
        .from("social_polaroids" as any)
        .select("id, image_url, caption, alt_text, position, is_active")
        .eq("is_active", true)
        .order("position", { ascending: true });
      if (mounted) {
        if (!error && rows) setData(rows as unknown as SocialPolaroid[]);
        setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading };
};